import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import InputMask from 'react-input-mask';
import { Link } from 'react-router-dom';
import InputSelect from '../../../common/components/form-elements/InputSelect';
import { TranslationFuncProp } from '../../../common/types/prop-types/common';
import imgChassiNumber from '../../assets/images/chassi-number.jpg';
import iconLapisEditar from '../../assets/images/icons/Cinzentos/lapisEditar.svg';
import cssCheckbox from '../../assets/scss/Checkbox.scss';
import cssForms from '../../assets/scss/Forms.scss';
import { config } from '../../common';
import { useRouter } from '../../common/RouterHooks';
import NewCardContainer, { NewCardProps } from './containers/NewCardContainer';

interface NewCardEvents {
    onCancel: () => void;
    onSubmit: () => void;
}

const HandlePlateType: React.FC<NewCardProps & TranslationFuncProp> = (props) => {
    if (props.newVehicleState.isEditing) {
        return (
            <React.Fragment>
                <li>
                    {!props.isForeignPlate &&
                        <React.Fragment>
                            <InputMask type="text" {...props.licensePlateString.inputProps} maskChar="" mask="**-**-**" className={cssForms.inputUppercase} />
                        </React.Fragment>
                    }
                    {props.isForeignPlate &&
                        <React.Fragment>
                            <input type="text" {...props.licensePlateForeign.inputProps} className={cssForms.inputUppercase} />
                        </React.Fragment>
                    }
                </li>
                <li>
                    <span className={'valor'}>{props.t('signup:extraInfo.licensePlate')}</span>
                </li>
                <li className={classNames([(config.BrandEnv === 'BMW' ? cssCheckbox.bmw : cssCheckbox.mini)])} style={{ padding: '10px 0px' }}>
                    <div className={cssCheckbox.inputCheckboxSmall}>
                        <label className={cssCheckbox.center}>
                            <input id="chkmatricula" type="checkbox" checked={props.isForeignPlate} onChange={props.onIsForeignPlateChange} />
                            <i />
                            <span>{props.t('isForeignPlate')}</span>
                        </label>
                    </div>
                </li>
                <li>
                    <label className={config.BrandEnv === 'BMW' ? cssForms.bmw : cssForms.mini}>
                        <div className={cssForms.info}>
                            <div>{props.t('signup:formFields.vin')}</div>
                            <div className={cssForms.tooltip}>
                                <img src={imgChassiNumber} alt="numero quadro documento carro" />
                            </div>
                        </div>
                        <InputMask type="text" {...props.vin.inputProps} maskChar="" mask="*****************" className={cssForms.inputUppercase} />
                    </label>
                </li>
            </React.Fragment>
        );
    }
    return (
        <li>
            <InputSelect {...props.licensePlateSelect} />
        </li>
    );
};

const NewCard: React.FC<NewCardEvents> = (containerProps) => {
    const { t } = useTranslation();
    const routeProps = useRouter();
    return (
        <NewCardContainer {...containerProps} t={t} routeProps={routeProps} >
            {(props: NewCardProps) => {
                if (props.isUserDataAvailable) {
                    return (
                        <React.Fragment>
                            <h4>{t('cards:newCard.header')}</h4>
                            <form className={cssForms.form}>
                                {props.currentStep === 1 &&
                                    <ul className={classNames(['no-bullet', 'dados-viatura'])}>
                                        <li>
                                            <span className={'valor'}>{t(`cards:newCard.description`)}</span>
                                        </li>
                                        <HandlePlateType t={t} {...props} />
                                        <li className="error-message">{props.licensePlateSelect.errorText}</li>
                                        <li className="error-message">{props.vin.errorText}</li>

                                        <li className={classNames([(config.BrandEnv === 'BMW' ? cssCheckbox.bmw : cssCheckbox.mini)])} style={{ padding: '10px 0px' }}>
                                            <div className={cssCheckbox.inputCheckboxSmall}>
                                                <label className={[cssForms.label, cssForms.checkbox].join(' ')}>
                                                    <span>
                                                        {t('cards:newCard.plateNotFound')} &nbsp;
                                                    </span>
                                                    <input type="checkbox" onChange={props.newVehicleState.changeEditMode} />
                                                    <i />
                                                </label>
                                            </div>
                                        </li>
                                        <li>
                                            <InputSelect {...props.preferedDealer} />
                                            <div className="error-message">{props.preferedDealer.errorText}</div>
                                        </li>
                                        <li>
                                            <div className={'button-group'}>
                                                <button type="button" className={classNames(['button', 'bttSubscrever'])} {...props.btnNext} onClick={(e) => { props.btnNext.onClick(e); }}>{t('cards:newCard.next')}</button>
                                                <button type="button" className={classNames(['button', 'bttCancelar'])} onClick={() => { containerProps.onCancel(); }}>{t('cancel')}</button>
                                            </div>
                                        </li>
                                    </ul>
                                }
                                {props.currentStep === 2 &&
                                    <div className={classNames(['no-bullet', 'dados-viatura', 'grid-x', 'grid-margin-x'])}>
                                        <div className={classNames(['cell', 'medium-12'])}>
                                            <span className={'valor'}>{t(`cards:newCard.confirmAddressDescription`)}</span>
                                        </div>
                                        <div className={classNames(['cell', 'medium-12'])}>
                                            <label className={config.BrandEnv === 'BMW' ? cssForms.bmw : cssForms.mini}>
                                                <div>{t('signup:formFields.address')}</div>
                                                <input type="text" {...props.address.inputProps} />
                                            </label>
                                            <div className="error-message">{props.address.errorText}</div>
                                        </div>
                                        <div className={classNames(['cell', 'medium-6'])}>
                                            <label className={config.BrandEnv === 'BMW' ? cssForms.bmw : cssForms.mini}>
                                                <div>{t('signup:formFields.addressNumber')}</div>
                                                <input type="text" {...props.addressNumber.inputProps} />
                                            </label>
                                            <div className="error-message">{props.addressNumber.errorText}</div>
                                        </div>
                                        <div className={classNames(['cell', 'medium-6'])}>
                                            <label className={config.BrandEnv === 'BMW' ? cssForms.bmw : cssForms.mini}>
                                                <div>{t('signup:formFields.addressFloor')}</div>
                                                <input type="text" {...props.addressFloor.inputProps} />
                                            </label>
                                            <div className="error-message">{props.addressFloor.errorText}</div>
                                        </div>
                                        <div className={classNames(['cell', 'medium-4'])}>
                                            <label className={config.BrandEnv === 'BMW' ? cssForms.bmw : cssForms.mini}>
                                                <div>{t('signup:formFields.postalCode')}</div>
                                                <input type="text" {...props.postalCode.inputProps} />
                                            </label>
                                            <div className="error-message">{props.postalCode.errorText}</div>
                                        </div>
                                        <div className={classNames(['cell', 'medium-8'])}>
                                            <label className={config.BrandEnv === 'BMW' ? cssForms.bmw : cssForms.mini}>
                                                <div>{t('signup:formFields.city')}</div>
                                                <input type="text" {...props.city.inputProps} />
                                            </label>
                                            <div className="error-message">{props.city.errorText}</div>
                                        </div>
                                        <div className={classNames(['cell', 'medium-12'])}>
                                            <div className="error-message">{props.submitErrorText}</div>
                                            <div className={'button-group'}>
                                                <button type="button" className={classNames(['button', 'bttSubscrever'])} {...props.btnSubmit} onClick={(e) => { props.btnSubmit.onClick(e, containerProps.onSubmit); }}>{props.btnSubmit.disabled ? t('loadingText') : t('cards:newCard.submit')}</button>
                                                <button type="button" className={classNames(['button', 'bttCancelar'])} onClick={(e) => { props.btnBack.onClick(e); }}>{t('cards:newCard.back')}</button>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </form>
                        </React.Fragment>
                    );
                } else {
                    return (
                        <React.Fragment>
                            <h4>{t('cards:newCard.header')}</h4>
                            <div>
                                <span className={'valor'}>{t(`cards:newCard.descriptionMissingData`)}</span>
                            </div>
                            <Link to={`${props.config.BaseURL}/profile`} className={classNames(['icon-link', 'margin-top-1'])}>
                                <img src={iconLapisEditar} alt={t('cards:customerInfo.editCustomer')} />{t('cards:customerInfo.editCustomer')}
                            </Link>
                        </React.Fragment>
                    );
                }
            }}
        </NewCardContainer>
    );
};

export default NewCard;
